// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '씨티씨바이오',
  targetSheetName: '정책현황',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험약가',
    commissionRate: '정책',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'NO',
    '구분',
    '제제명',
    '제품명',
    '보험약가',
    '보험코드',
    '정책',
    '비고',
    '열1',
    '열2',
  ],
});
